import { useMemo } from 'react'
import { useMailboxReplyAnalytics, MailboxReplyData } from './useMailboxReplyAnalytics'

export interface ClientMailboxReplyFilter {
  clientName: string
  timePeriod: 'today' | 'yesterday' | 'last_7_days' | 'last_14_days' | 'last_30_days'
}

export function useClientMailboxReplyAnalytics(filter?: ClientMailboxReplyFilter) {
  const { data: allReplyData = [], isLoading, refetch } = useMailboxReplyAnalytics()

  const filteredData = useMemo(() => {
    if (!filter) return allReplyData

    return allReplyData.filter(mailbox => {
      // Filter by client name
      const matchesClient = mailbox.client_name === filter.clientName
      
      // Filter by time period - only show mailboxes that have replies in the selected period
      let hasReplyInPeriod = false
      switch (filter.timePeriod) {
        case 'today':
          hasReplyInPeriod = mailbox.replies_today > 0
          break
        case 'yesterday':
          // For yesterday, we need replies in the last 2 days but not today
          hasReplyInPeriod = mailbox.replies_7d > mailbox.replies_today && mailbox.replies_today === 0
          break
        case 'last_7_days':
          hasReplyInPeriod = mailbox.replies_7d > 0
          break
        case 'last_14_days':
          hasReplyInPeriod = mailbox.replies_14d > 0
          break
        case 'last_30_days':
          hasReplyInPeriod = mailbox.total_replies > 0
          break
      }

      return matchesClient && hasReplyInPeriod
    })
  }, [allReplyData, filter])

  return {
    data: filteredData,
    isLoading,
    refetch
  }
}